<template>
  <v-container
  class="pa-0 mb-4"
  fluid
  >
    <v-row
      align="start"
      no-gutters
    >
      <v-col
        cols="7"
      >
        <v-row
          justify="center"
          align="center"
          no-gutters
        >
          <v-col
            cols="3"
          >
            <v-avatar
            :size="$vuetify.breakpoint.lgAndDown ? 30 : 34"
            :color="providerColorAndText().color"
            >
              <span
              class="black--text provider-icon-text"
              :class="[
              {'md': $vuetify.breakpoint.lgAndDown },
              providerColorAndText().textColor
              ]"
              >
                {{ providerColorAndText().text }}
              </span>
            </v-avatar>
          </v-col>
          <v-col
            cols="9"
          >
            <v-row
              no-gutters
            >
              <v-col
                cols="12"
              >
                <span
                class="provider-carrier-text"
                :class="{'md': $vuetify.breakpoint.lgAndDown }"
                >
                  {{ shipmentTransportMode.translate ? $t(`shipments.${shipmentTransportMode.carrier}`) : shipmentTransportMode.carrier }}
                </span>
                </v-col>
                <v-col
                  cols="12"
                >
                <span
                class="provider-transport-mode-text"
                :class="{'md': $vuetify.breakpoint.lgAndDown }"
                >
                  {{ shipmentTransportMode.translate ? $t(`shipments.${shipmentTransportMode.transportMode}`) : shipmentTransportMode.transportMode }}
                </span>
              </v-col>
              <v-col
                  cols="12"
                  v-if="shipmentTransportMode.subtitle"
                >
                <span
                class="provider-transport-mode-text"
                :class="{'md': $vuetify.breakpoint.lgAndDown }"
                >
                  {{ shipmentTransportMode.subtitle }}
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="3"
      >

      </v-col>
      <v-col
        cols="2"
      >
      <v-row
      justify="end"
      class="pr-2"
      >
        <v-icon
          v-if="!isEditing"
          :size="$vuetify.breakpoint.lgAndDown ? '12px' : '14px'"
          @click="handleEditing"
        >
          {{ 'fas fa-pen' }}
        </v-icon>
        <v-icon
          v-else
          :size="$vuetify.breakpoint.lgAndDown ? '12px' : '14px'"
          @click="handleRemoving"
        >
          {{ 'fas fa-trash-alt' }}
        </v-icon>
      </v-row>
      </v-col>
    </v-row>
    <v-expand-transition>
        <v-row
          no-gutters
          v-show="isEditing"
        >
          <v-card
            class="elevation-0 provider-card"
            max-height="55vh"
            width="100%"
            color="wrld_background"
          >
            <v-container
              class="pa-0 ma-0"
              fill-height
              fluid
            >
            <v-row
              align="start"
            >
              <v-col
                cols="12"
              >
                <v-row
                  v-if="getIsLoadingProviders"
                  no-gutters

                  justify="center"
                >
                  <i class="fas fa-spinner fa-spin spinner-icon fa-3x wrld_grey--text"></i>
                </v-row>
                <template
                  v-else
                >
                  <v-row
                    no-gutters
                    align-start
                    justify-center
                    v-show="getListPossibleProvidersMenuFilters != null"
                  >
                    <v-col
                      v-for="menuButton in getListPossibleProvidersMenuFilters"
                      cols="4"
                      :key="menuButton.type"
                    >
                    <v-chip
                      :outlined="getProvidersCurrentMenuFilters !== menuButton.type"
                      class="rounded-lg pa-2"
                      color="wrld_grey"
                      @click="handleMenuFilter(menuButton.type)"
                    >
                      <v-icon
                        left
                        size="10"
                        class="ma-0"
                        :color="handleProviderColor(menuButton.type)"
                      >
                        fas fa-circle
                      </v-icon>
                      <span
                        class="provider-menu-chip-text wrld_black--text font-weight-bold"
                        :class="{'md': $vuetify.breakpoint.lgAndDown }"
                      >
                        {{ $t(`shipments.${menuButton.label}`) }}
                      </span>
                      <span
                        class="font-weight-bold"
                      >
                        {{ menuButton.count }}
                      </span>
                    </v-chip>
                    </v-col>
                  </v-row>
                  <v-row
                    class="pa-0 mx-0 my-2"
                  >
                  <v-col
                    cols="12"
                    class="pa-0"
                  >
                    <v-text-field
                    outlined
                    :label="$t('shipments.search_and_select_transport_mode')"
                    prepend-inner-icon="search"
                    v-model="search"
                    dense
                    hide-details="auto"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    class="pa-0"
                  >
                    <ShipmentsContextSetCustomProvider
                      :shipmentID="shipment.id"
                      @edit="handleEditCustomProvider"
                      @close="handleCloseCustomProvider"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    class="pt-1"
                    v-show="!editingCustomProvider"
                  >
                    <v-list
                      color="wrld_background"
                      max-width="420px"
                      class="overflow-y-auto"
                      max-height="40vh"
                      min-height="40vh"
                      v-if="getFilteredListPossibleProviders != null"
                    >
                    <v-scroll-y-reverse-transition
                      group
                    >
                      <template
                        v-for="(item, index) in searchListOfAvailableProviders"
                      >
                        <v-hover
                          v-slot:default="{ hover }"
                          :open-delay="100"
                          :key="`${item.__typename}_${index}_hover`"
                        >
                          <v-list-item
                          :class="{'hover': hover}"
                          class="pl-1 pr-2 provider-list-item"
                          :key="`${item.__typename}_${index}`"
                          @click="handleSelection(item)"
                          >
                            <v-list-item-avatar>
                              <v-avatar
                                :size="$vuetify.breakpoint.lgAndDown ? 30 : 34"
                                :color="providerColorAndText(item.__typename).color">
                                  <span
                                  class="provider-icon-text"
                                  :class="[{
                                    'md': $vuetify.breakpoint.lgAndDown,
                                  }, providerColorAndText(item.__typename).textColor]"
                                  >
                                    {{ providerColorAndText(item.__typename).text }}
                                  </span>
                                </v-avatar>
                            </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title
                            class="provider-carrier-text"
                            :class="{'md': $vuetify.breakpoint.lgAndDown }"
                            >{{ item.organization.name }}
                            </v-list-item-title>
                            <v-list-item-subtitle
                            class="provider-transport-mode-text"
                            :class="{'md': $vuetify.breakpoint.lgAndDown }"
                            >{{ item.subtitle }}
                              <v-container
                              v-show="item.isOpen && item.__typename !== 'Quote'"
                              fluid class="pa-0 ma-0"
                              >
                              <v-row no-gutters>
                                  <v-col
                                    cols="12"
                                  >
                                    {{ item.extraSubtitle }}
                                  </v-col>
                                  <v-col cols="12"
                                  >
                                    <v-row no-gutters justify="start">
                                      <span v-for="(equipment) in item.equipment"
                                      :key="equipment"

                                      class="provider--equipment equipment text-no-wrap">
                                        {{ $t(`equipment.${equipment}`) }}
                                      </span>
                                      <span v-for="(label, index) in item.labels"
                                      :key="`${label}_${index}`"
                                      class="provider--equipment label text-no-wrap">
                                        {{ label }}
                                      </span>
                                    </v-row>
                                  </v-col>
                              </v-row>
                              </v-container>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn
                              x-small
                              color="wrld_grey"
                              class="elevation-0 pt-1"
                              v-show="item.__typename != 'Quote'"
                              @click="handleExtraInfo(index)"
                              v-on:click.stop
                            >
                              <v-icon
                                  size="13"
                                  style="margin-bottom: 3px;"
                                >
                                  {{ item.isOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down'}}
                                </v-icon>
                            </v-btn>
                            <span
                            v-if="item.cost != null"
                            class="provider-carrier-text"
                            :class="{'md': $vuetify.breakpoint.lgAndDown }"
                            >
                              {{ item.cost.price | humanizeNumber }} {{ item.cost.currency }}
                            </span>
                            <span
                            v-else-if="item.__typename === 'Quote'"
                            class="provider-carrier-text"
                            :class="{'md': $vuetify.breakpoint.lgAndDown }"
                            >
                              {{ item.status }}
                            </span>
                          </v-list-item-action>
                          </v-list-item>
                        </v-hover>
                      </template>
                      </v-scroll-y-reverse-transition>
                    </v-list>
                  </v-col>
                  </v-row>
                </template>
              </v-col>
            </v-row>
            </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="!editingCustomProvider"
                small
                dark
                class="elevation-0 btn-text-transform-none"
                color="wrld_black"
                style="padding: 0 20px;"
                @click="handleDoneEditing"
              >
                {{ $t('buttons.done') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-row>
    </v-expand-transition>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import ShipmentsContextSetCustomProvider from '@/components/shipmentsByDay/context/ShipmentsContextSetCustomProvider'
  export default {
    name: 'ShipmentsContextSetProvider',
    components: {
      ShipmentsContextSetCustomProvider
    },
    data() {
      return {
        isEditing: false,
        search: null,
        listOfAvailableProviders: null,
        editingCustomProvider: false
      }
    },
    mounted () {
      // Init context view when switching shipments
      this.$emit('provider-editing', false)
    },
    methods: {
      ...mapActions({
        setListPossibleProviders: 'shipmentsContext/setListPossibleProviders',
        setSelectedProvider: 'shipmentsContext/setSelectedProvider',
        setProviderMenuFilter: 'shipmentsContext/setProviderMenuFilter',
        removeProviderMenuFilter: 'shipmentsContext/removeProviderMenuFilter',
        setCustomProvider: 'shipmentsContext/setCustomProvider'
      }),
      handleEditing () {
        this.isEditing = true
        this.$emit('provider-editing', this.isEditing)
        if (this.isEditing) {
          this.setListPossibleProviders({ shipmentID: this.shipment.id })
        }
      },
      handleRemoving () {
        this.setSelectedProvider({
          shipmentID: this.shipment.id,
          providerID: null,
          providerType: null
        })
      },
      handleDoneEditing () {
        this.isEditing = false
        this.$emit('provider-editing', this.isEditing)
      },
      handleExtraInfo (index) {
        // let list = this.listOfAvailableProviders
        this.listOfAvailableProviders[index].isOpen = !this.listOfAvailableProviders[index].isOpen
        // this.listOfAvailableProviders = [ ...list ]
      },
      handleSelection (item) {
        if (item.type === 'Express') {
          this.setCustomProvider({
            shipmentID: this.shipment.id,
            providerName: item.organization.name,
            transportMode: item.type,
            price: item.cost.price,
            currency: item.cost.currency,
          })
        } else {
          this.setSelectedProvider({
            shipmentID: this.shipment.id,
            providerID: item.providerID,
            providerType: item.type
          })
        }
      },
      handleMenuFilter (attribute) {
        if (this.getProvidersCurrentMenuFilters === attribute) {
          this.removeProviderMenuFilter({ attribute })
        } else {
          this.setProviderMenuFilter({ attribute })
        }
      },
      handleEditCustomProvider () {
        this.editingCustomProvider = true
      },
      handleCloseCustomProvider () {
        this.editingCustomProvider = false
      },
      handleProviderColor (type) {
        switch (type) {
          case 'OnePLProvider':
            return 'wrld_green'
          case 'TwoPLProvider':
            return 'wrld_blue'
          case 'Quote':
            return 'wrld_red'
          case 'Express':
            return 'wrld_black'
          default:
            return 'wrld_grey'
        }
      },
      providerColorAndText (type = this.getSelectedShipment.type) {
        switch (type) {
          case 'OnePL':
            return {
              color: 'wrld_green',
              text: '1PL'
            }
          case 'TwoPL':
            return {
              color: 'wrld_blue',
              text: '2PL'
            }
          case 'ThreePL':
            return {
              color: 'wrld_red',
              text: '3PL'
            }
          case 'Express':
            return {
              color: 'wrld_black',
              textColor: 'wrld_grey--text',
              text: 'Exp'
            }
          case 'OnePLProvider':
            return {
              color: 'wrld_green',
              text: '1PL'
            }
          case 'TwoPLProvider':
            return {
              color: 'wrld_blue',
              text: '2PL'
            }
          case 'Quote':
            return {
              color: 'wrld_red',
              text: '3PL'
            }
          default:
            return {
              color: 'wrld_grey',
              text: '?'
            }
        }
      },
    },
    computed: {
      ...mapGetters({
        getSelectedShipment: 'shipmentsContext/getSelectedShipment',
        getIsLoadingProviders: 'shipmentsContext/getIsLoadingProviders',
        getFilteredListPossibleProviders: 'shipmentsContext/getFilteredListPossibleProviders',
        getSelectedShipmentTransportMode: 'shipmentsContext/getSelectedShipmentTransportMode',
        getListPossibleProvidersMenuFilters: 'shipmentsContext/getListPossibleProvidersMenuFilters',
        getProvidersCurrentMenuFilters: 'shipmentsContext/getProvidersCurrentMenuFilters'
      }),
      shipment () {
        return this.getSelectedShipment
      },
      shipmentTransportMode () {
        return this.getSelectedShipmentTransportMode
      },
      searchListOfAvailableProviders () {
        return this.listOfAvailableProviders.filter(item => {
          if(!this.search) return this.listOfAvailableProviders;
           return (item.description.toLowerCase().includes(this.search.toLowerCase()))
        })
      }
    },
    watch: {
      getFilteredListPossibleProviders: {
        immediate: true,
        deep: true,
        handler(val) {
          this.search = null
          if (val != null) {
            this.listOfAvailableProviders = [ ...val ]
          } else {
            this.listOfAvailableProviders = null
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .provider-icon-text {
    font-size: 13px;
    font-weight: 500;
    &.md {
      font-size: 12px;
    }
  }
  .provider-list-item {
    border-radius: 5px;
    &.hover {
      background-color: var(--v-wrld_grey_two-base) !important;
    }
  }
  .provider-carrier-text {
    font-size: 13px;
    color: var(--v-wrld_black-base);
    font-weight: 500;
    &.md {
      font-size: 12px;
    }
  }
  .provider-transport-mode-text {
    font-size: 13px;
    color: var(--v-wrld_grey-base);
    font-weight: 500;
    &.md {
      font-size: 12px;
    }
  }
  .provider--equipment {
    margin-right: 5px;
    padding: 2px 4px;
    border-radius: 15px;
  }
  .status {
    background-color: var(--v-wrld_yellow_orange-base);
  }
  .label {
    background-color: var(--v-wrld_green-base);
  }
  .equipment {
      color: white;
      background-color: var(--v-wrld_red_label-base);
  }
  .provider-menu-chip-text {
    font-size: 13px;
    margin-left: 4px;
    margin-right: 4px;
    &.md {
      font-size: 12px;
    }
  }
</style>
